<template>
  <span class="firmware-status-mini"> fv{{ formattedCurrentVersion }} </span>
</template>

<script>
  export default {
    name: 'FirmwareStatusMini',

    props: {
      currentVersion: {
        type: Array,
        required: true,
      },
    },

    computed: {
      formattedCurrentVersion() {
        return this.currentVersion.join('.');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .firmware-status-mini {
    display: inline-flex;
    align-items: center;
  }
</style>
